import React, { Component } from 'react';
import { TextArea } from 'semantic-ui-react';
import * as _ from 'lodash';
import shortid from 'shortid';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { setElementChanged } from 'State/dirtyTracking/actions';

class TrackedTextAreaContainer extends Component {
  static propTypes = {
    initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    showFocus: PropTypes.bool,
  };

  componentDidMount() {
    this.id = shortid.generate();
  }

  onInput = e => {
    this.props.setElementChanged(
      this.id,
      this.props.initialValue,
      e.target.value
    );
  };

  componentDidUpdate() {
    if (this.props.showFocus) {
      this.TextArea.focus();
    }
  }

  render() {
    const rest = _.omit(this.props, [
      'initialValue',
      'setElementChanged',
      'showFocus',
    ]);

    return (
      <div>
        <label>{this.props.label} </label>
        <div>
          <TextArea
            {...rest}
            onInput={this.onInput}
            ref={instance => {
              this.TextArea = instance;
            }}
          />
        </div>
      </div>
    );
  }
}

const TrackedTextArea = connect(null, {
  setElementChanged,
})(TrackedTextAreaContainer);

export { TrackedTextArea };



// WEBPACK FOOTER //
// ./src/components/tracked/TrackedTextArea.js